var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"p-4"},_vm._l((_vm.groups),function(group){return _c('screen-groups-item',{key:group.screenGroupId,attrs:{"group":group}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }